module.exports = __webpack_public_path__ + "img/energyDistribution.1f23b4fd.png";